import {makeAutoObservable} from "mobx";

class CustomPrintModalStore {
    printModal = {
        show: false,
        url: '',
		method: 'GET',
    }

    constructor() {
        makeAutoObservable(this)
    }

	// url = `/api/v2/general/patients/${printModal.patientId}/results/${printModal.resultId}`
    showPrintModal(url, method='GET') {
        this.printModal = {
			show: true,
			url: url,
			method: method,
		}
    }

    hidePrintModal() {
        this.printModal = {
			show: false,
			url: '',
		}
    }

}

export default new CustomPrintModalStore()
